import { render } from "./globalSet.vue?vue&type=template&id=dcd8e4c6&scoped=true"
import script from "./globalSet.vue?vue&type=script&lang=js"
export * from "./globalSet.vue?vue&type=script&lang=js"

import "./globalSet.vue?vue&type=style&index=0&id=dcd8e4c6&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcd8e4c6"]])

export default __exports__